/**
 * Theme JS — Replaces layout.theme.js (jQuery-dependent webpack bundle)
 * Pure vanilla JavaScript
 */
(function() {
  'use strict';

  // Remove no-js class
  document.documentElement.className = document.documentElement.className.replace('no-js', '');

  // Cookie support detection
  if (window.navigator.cookieEnabled) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // Focus hash helper
  function focusHash() {
    var hash = window.location.hash;
    if (hash) {
      var el = document.querySelector(hash);
      if (el) el.focus();
    }
  }

  // Scrolling header
  function initScrollingHeader() {
    var header = document.getElementById('shopify-section-header') || document.getElementById('header__container');
    if (!header) return;

    var lastKnownScroll = 0;
    var ticking = false;

    function onScroll() {
      lastKnownScroll = window.scrollY || document.documentElement.scrollTop;

      if (!ticking) {
        window.requestAnimationFrame(function() {
          if (lastKnownScroll > 100) {
            header.classList.add('scrollingHeader');
          } else if (lastKnownScroll < 50) {
            header.classList.remove('scrollingHeader');
          }
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Header margin
  function initHeaderMargin() {
    var headerContainer = document.getElementById('header__container');
    if (!headerContainer) return;

    function setMargin() {
      var height = headerContainer.offsetHeight;
      document.body.style.marginTop = (height + 10) + 'px';
    }

    setMargin();
    window.addEventListener('resize', setMargin);
  }

  // Off-canvas reset margin
  function initOffCanvas() {
    var offCanvas = document.getElementById('offCanvas');
    if (offCanvas) {
      // When off-canvas opens, reset body margin (Foundation event)
      offCanvas.addEventListener('opened.zf.offCanvas', function() {
        document.body.style.marginTop = '0';
      });
      offCanvas.addEventListener('closed.zf.offCanvas', function() {
        initHeaderMargin();
      });
    }
  }

  // Announcement carousel
  function initAnnouncementCarousel() {
    var carousel = document.querySelector('.announcement__carousel');
    if (carousel && window.Carousel) {
      new window.Carousel(carousel, {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 4750
      });
    }
  }

  // Membership form conditional fields
  function initMembershipForm() {
    var riderContainer = document.getElementById('what-do-you-ride-container');
    var refereeContainer = document.getElementById('bike-shed-referee-container');

    if (riderContainer) riderContainer.style.display = 'none';
    if (refereeContainer) refereeContainer.style.display = 'none';

    var riderInputs = document.querySelectorAll('#please-confirm-that-you-are-a-motorcycle-rider input');
    riderInputs.forEach(function(input) {
      input.addEventListener('click', function() {
        if (riderContainer) {
          riderContainer.style.display = this.value === 'Yes' ? '' : 'none';
        }
      });
    });

    var refereeInputs = document.querySelectorAll('#do-you-have-a-referee input');
    refereeInputs.forEach(function(input) {
      input.addEventListener('click', function() {
        if (refereeContainer) {
          refereeContainer.style.display = this.value === 'Yes' ? '' : 'none';
        }
      });
    });
  }

  // Reviews tab link
  function initReviewsLink() {
    var reviewsLink = document.getElementById('reviewsLink');
    if (reviewsLink) {
      reviewsLink.addEventListener('click', function(e) {
        e.preventDefault();
        var reviewsTab = document.querySelector('[data-tabs-target="reviews"]') || document.querySelector('a[href="#reviews"]');
        if (reviewsTab) reviewsTab.click();
      });
    }
  }

  // Mega menu hover
  function initMegaMenu() {
    document.querySelectorAll('.megamenuList').forEach(function(item) {
      item.addEventListener('mouseover', function() {
        var target = this.getAttribute('data-megamenuList');
        document.querySelectorAll('.mega-menu-collection').forEach(function(col) {
          col.classList.remove('selected');
        });
        var targetEl = document.getElementById(target);
        if (targetEl) targetEl.classList.add('selected');
      });
    });
  }

  // Search toggle
  function initSearchToggle() {
    var searchMenu = document.querySelector('.search-menu');
    var accountMenu = document.querySelector('.account-menu');
    var searchIcon = document.getElementById('search-icon');
    var accountIcon = document.getElementById('account-icon');

    if (searchIcon && searchMenu) {
      searchIcon.addEventListener('click', function(e) {
        e.preventDefault();
        var isVisible = searchMenu.style.display !== 'none';
        searchMenu.style.display = isVisible ? 'none' : '';
        if (accountMenu) accountMenu.style.display = 'none';
      });
    }

    if (accountIcon && accountMenu) {
      accountIcon.addEventListener('click', function(e) {
        e.preventDefault();
        var isVisible = accountMenu.style.display !== 'none';
        accountMenu.style.display = isVisible ? 'none' : '';
        if (searchMenu) searchMenu.style.display = 'none';
      });
    }

    // Close menus on menu item hover
    document.querySelectorAll('.menu-item').forEach(function(item) {
      item.addEventListener('mouseover', function() {
        if (searchMenu) searchMenu.style.display = 'none';
        if (accountMenu) accountMenu.style.display = 'none';
      });
    });
  }

  // Add to cart opens off-canvas
  function initAddToCartTrigger() {
    var addCartBtn = document.getElementById('addCart');
    if (addCartBtn) {
      addCartBtn.addEventListener('click', function() {
        var offCanvasCart = document.getElementById('offCanvasCart');
        if (offCanvasCart && typeof Foundation !== 'undefined') {
          try {
            var $el = window.jQuery ? window.jQuery('#offCanvasCart') : null;
            if ($el && $el.foundation) $el.foundation('open');
          } catch(ex) {
            // Foundation not available, try toggle class
            offCanvasCart.classList.add('is-open');
          }
        }
      });
    }
  }

  // Password page form toggle
  function initPasswordForm() {
    var recoverForm = document.getElementById('passwordRecoverForm');
    var loginForm = document.getElementById('loginForm');
    var recoverLink = document.getElementById('passwordRecover');
    var cancelLink = document.getElementById('recover_cancel');

    if (recoverForm) recoverForm.style.display = 'none';

    if (recoverLink) {
      recoverLink.addEventListener('click', function(e) {
        e.preventDefault();
        if (loginForm) loginForm.style.display = 'none';
        if (recoverForm) {
          setTimeout(function() { recoverForm.style.display = ''; }, 300);
        }
      });
    }

    if (cancelLink) {
      cancelLink.addEventListener('click', function(e) {
        e.preventDefault();
        if (recoverForm) recoverForm.style.display = 'none';
        if (loginForm) {
          setTimeout(function() { loginForm.style.display = ''; }, 300);
        }
      });
    }
  }

  // BFCache — reload on back/forward navigation
  function initBfcache() {
    window.addEventListener('pageshow', function(event) {
      if (event.persisted) {
        window.location.reload();
      }
    });
  }

  // Currency form
  function initCurrencyForm() {
    var currencySelect = document.querySelector('.shopify-currency-form select');
    if (currencySelect) {
      currencySelect.addEventListener('change', function() {
        this.form.submit();
      });
    }
  }

  // Initialize everything
  function init() {
    focusHash();
    initScrollingHeader();
    initHeaderMargin();
    initOffCanvas();
    initAnnouncementCarousel();
    initMembershipForm();
    initReviewsLink();
    initMegaMenu();
    initSearchToggle();
    initAddToCartTrigger();
    initPasswordForm();
    initBfcache();
    initCurrencyForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
